import { useState, useEffect, useRef } from 'react';
import { useLang } from '../context/LangContext';

const LANG_DATA = {
  es: { flagSrc: 'https://flagcdn.com/w40/es.png', flagAlt: 'España',  label: 'Español'  },
  en: { flagSrc: 'https://flagcdn.com/w40/us.png', flagAlt: 'USA',     label: 'English'  },
  fr: { flagSrc: 'https://flagcdn.com/w40/fr.png', flagAlt: 'France',  label: 'Français' },
  pt: { flagSrc: 'https://flagcdn.com/w40/br.png', flagAlt: 'Brasil',  label: 'Português'},
};

export default function LangSelector() {
  const { lang, changeLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handler = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  const current = LANG_DATA[lang];

  return (
    <div className={`lang-selector${open ? ' open' : ''}`} ref={ref}>
      <div className="lang-current" onClick={(e) => { e.stopPropagation(); setOpen(o => !o); }}>
        <img className="lang-flag" src={current.flagSrc} alt={current.flagAlt} />
        <span className="lang-name">{current.label}</span>
        <svg className="lang-chevron" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="2 4 6 8 10 4" />
        </svg>
      </div>
      <div className="lang-dropdown">
        {Object.entries(LANG_DATA).map(([code, data]) => (
          <button
            key={code}
            className={`lang-option${lang === code ? ' active' : ''}`}
            onClick={(e) => { e.stopPropagation(); changeLang(code); setOpen(false); }}
          >
            <img className="lang-flag" src={data.flagSrc} alt={data.flagAlt} />
            <span className="lang-label">{data.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
